<template>
  <div style="margin-top: 200px">
    <center>
      {{ title }}
    </center>
  </div>
</template>

<script>
import Vue from 'vue';
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {postAction} from '@/api/manage';
import {Toast} from 'vant';

export default {
  components: {[Toast.name]: Toast},
  data() {
    return {
      code: '',
      uOpenId: '',
      state: '',
      departCode: '',
      title: '授权成功，正在校验数据……',
      url: '/web/api/auth/bindOilStation'
    };
  },
  mounted() {
    this.code = this.$route.query.code;
    this.state = this.$route.query.state;
    this.urls = decodeURI(this.$route.query.urls);
    this.toQs();
  },
  methods: {
    toQs() {
      const that = this;
      postAction(that.url, {
        wxCode: that.code,
        uOpenId: that.state.split('@')[0],
        departCode: that.state.split('@')[1]
      }).then(res => {
        window.location.href = localStorage.getItem('urls');
      }).finally(() => {
      })
    }
  }
};
</script>

<style lang="less">
</style>
